"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsTextFieldEmail = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _DmsTextFieldMasked = require("./DmsTextFieldMasked");
var _DmsTextField = require("./DmsTextField");
const _excluded = ["name", "label", "placeholder"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * Mask function for email addresses.
 * @param {string} value - The input value.
 * @returns {string} The masked value.
 */
const EmailMask = value => {
  // Remove any characters that are not valid in an email address
  const sanitizedValue = value.replace(/[^a-zA-Z0-9.@-_]/g, "").toLowerCase();

  // Basic email validation (e.g., check for '@' and '.' presence)
  const [localPart, domainPart] = sanitizedValue.split("@");
  if (domainPart && domainPart.includes(".")) {
    return sanitizedValue;
  }

  // Return sanitized value
  return sanitizedValue;
};

/**
 * TextField component for email addresses.
 * @param {Object} props - The component props.
 * @param {string} props.label - The label text.
 * @param {string} props.value - The input value.
 * @param {boolean} props.disabled - Whether the field is disabled.
 * @param {boolean} props.fullWidth - Whether the field should take up the full width.
 * @param {boolean} props.required - Whether the field is required.
 * @param {string} props.placeholder - The placeholder text.
 * @returns {JSX.Element} The rendered TextField component.
 */
const DmsTextFieldEmail = _ref => {
  let {
      name = "email",
      label = "Email",
      placeholder = "example@domain.com"
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_DmsTextFieldMasked.DmsTextFieldMasked, _extends({
    name: name,
    label: label,
    placeholder: placeholder
  }, props, {
    maskFunction: EmailMask
  }));
};
exports.DmsTextFieldEmail = DmsTextFieldEmail;